// TODO we need to keep this synced with UnicornConstants

export class FoundationsConstants {
    static COOKIE_NAME = 'AuthToken'
    static WORKSPACE_LIMIT = 9
    static TOKEN_STR = 'hl-user-token'
    static TOKEN_EXP_STR = 'hl-user-token-expiration'
    static BASE_URL = window.baseURL
    static DEVELOPER_MODE = false
    static THEME = 'classic' // default theme
    // static FOUNDATIONSLOADER = FoundationsLoader;
    static BANNER_UNINITIALIZED_TEXT = 'WARNING-UNINITIALIZED SYSTEM'
    static SESSION_EXTEND_EVENTS = ['click', 'touchstart', 'mousemove', 'scroll']
    static GENERAL_EVENTS_STR = 'generalEvents'
    static LAST_USER_INTERACTION = 'last-user-interaction'
    static TOKEN_REFRESH_IN_PROGRESS = 'token-refresh-in-progress'
    static NEW_USER = 'new-user-token'
    static OPENID_STATE = 'openId-state'
    static PROXY_USER = 'proxy-user'

    static VISUAL_UNIT_TYPES = {
        TABLE_VIEW: 1,
        SUMMARY_VIEW: 2,
        PIE_CHART: 3,
        BAR_CHART: 4,
        LINE_CHART: 5,
        STACKEDBAR_CHART: 6,
        COLUMNGROUP_CHART: 7,
        SCATTER_CHART: 8,
        HEATMAP_CHART: 9,
        STACKEDCOLUMN_CHART: 10, //StackedColumn
    }

    static PrivacyLock = ['OpenUnlocked', 'LockedNotPrivate', 'PrivateNotVisible']

    static PrivacyLockText = {
        [FoundationsConstants.PrivacyLock[0]]: 'Unlocked, Open and Available',
        [FoundationsConstants.PrivacyLock[1]]:
            'Shared Lock, can be changed only by Owner and Administrators',
        [FoundationsConstants.PrivacyLock[2]]:
            'Locked(Private), visible only to Owner and Administrators',
    }

    static PRIMARY_COLOR = '#2969b7'

    static colorMappings ={
        white: "#fff",
        grey: "#ddd",
        green: "#CEFDD0",
        yellow: "#fcffc6",
        blue: "#dff0ff",
        purple: "#f4dfff",
        red: "#ffdfdf",
        orange: "#ffdfbf",
      }

    static HLDATATYPE = {
        HLAge: '6',
        HLCount: '1',
        HLDate: '10',
        HLDuration: '3',
        HLList: '4',
        HLMoney: '2',
        HLPercentage: '8',
        HLNumber: '14',
        HLDecimal: '15',
        HLAgeDays: '13',
        HLText: '12',
        HLTime: '11',
        HLSearchList: '5',
        HLBusinessParameter: '16',
        HLSingleValueReport: '17',
        HLBooleanTF: '18',
        HLYesNo: '19',
        HLMeasureSet: '20',
    }
    static CHARTTYPE = {
        3: 'pie',
        4: 'bar',
        5: 'line',
        6: 'stackedBar',
        7: 'columnGroup',
        8: 'scatter',
        9: 'heatMap',
        10: 'stackedColumn',
    }
    static ArrayMultipleAxisColor = ['#4572A7', '#89A54E', '#AA4643', '#870FA5', '#C7891F']

    static TEMPLATE_BASE_PATH_LITERAL = 'templates.UnicornTemplates.app.Templates.theme.classic'
    
    static DisplayMode = {
		Reserved : 0,
		Unset : 1,
		Classic : 2,
		Night : 3,
		Unknown : -1,
	}

   static worklist_guid = {
        caseform:'22A7266A-9F73-4F04-8E9D-D8BD8F240458',
        open:'169B4395-77F4-4A88-9B1F-E6C3951397D0',
        claimed:'BF4D6002-194E-4D44-8C65-8E96F19BE01C',
        ready:'2C89BE53-2DFC-4788-8E36-B47234BF0D7C',
        reject:'9AC5727F-5439-43CD-AF9D-744B3EDE132D',
        workloadrequest_form:'guidfor_workloadrequestform',
        workloadrequest_openlist:'guidfor_workloadopenlist',
        workloadrequest_pendinglist:'guidfor_workloadpending',
        workloadrequest_approvedlist:'guidfor_workloadapproved',
        workloadrequest_declinedlist:'guidfor_workloaddeclined',
        lms_form:'guidfor_lms_form',
    }

    static StatPortalButtons = {
        Removefrommylist: 'Remove from my list',
        Addtomylist: 'Add to my list',
    }

    static enumVUCallerType = {
        Default:"Default",
        AutoRefresh:"AutoRefresh",
        Refresh:"Refresh",
        Page:"Page",
        ShowRows:"ShowRows",
        Sort:"Sort",
        Explore:"Explore",
        Create:"Create"
    }
    static Response ={
        Success:"success",
        Error:"error",
    }
    static Status ={
        Success:1,
        Error:0,
    }
    static enumSearchListType ={
        RadioButton : "RadioButton",
        CheckBox : "CheckBox"
   
    }
    static enumVULabel = {
        SingularLower : "report",
        SingularProper : "Report",
        PluralLower : "reports",
        PluralProper : "Reports"
    } 
    static FetchVuParamsDisplayType ={
        AggricateList: 'HL_AGGRICATELIST',
        BusinessParameterList: 'HL_BUSINESSPARAMETER',
        SingleValueReportList: 'HL_SINGLE_VALUE_REPORT',
        HLLIST: 'HLLIST',
        HL_SEARCHLIST: 'HL_SEARCHLIST',
        GENERIC_FILTERS: 'GENERIC_FILTERS',
        BINLIST: "BINLIST"
    }

    static DonotDisplayFilterValues :string[] = ["has valid duration", "does not have valid duration", "documented and available",
        "not documented", "recorded and available", "Is Valid", "not recorded", "Not Valid"]
    
    static reportFailedOperationStatusMessage = "Please add at least one filter, typically with a date range, such as Date of Service."
    static toastrMessage = {
        "workspacesharesuccess": "Workspace has been shared with user successfully.",
        "workspacesharefailure": "Sorry, sharing workspace with this user failed. Please try again.",
        "workspacecreationsuccess": "Workspace saved successfully.",
        "workspacecreationfailure": "Sorry, saving new workspace failed. Please try again.",
        "workspaceeditionsuccess": "Workspace has been edited successfully.",
        "workspaceeditionfailure": "Sorry, editing workspace failed. Please try again.",
        "workspaceupdationsuccess": "Workspace saved successfully.",
        "workspaceupdationfailure": "Sorry, saving workspace failed. Please try again.",
        "workspacedetachedsuccess": "Workspace has been detached (released) successfully.",
        "workspacedetachedfailure": "Sorry, detaching workspace failed. Please try again.",
        "workspacedelatesuccess": "Workspace has been deleted successfully.",
        "workspacedelatefailure": "Sorry, deleting workspace failed. Please try again.",
        "reportcreationsuccess": "Report attached successfully.",
        "reportdetachsuccess": "Report detached successfully",
        "reportcreationfailure": "Sorry, attaching report failed. Please try again.",
        "reportreordersuccess": "Reports reordered successfully.",
        "reportreorderfailure": "Sorry, reports reordered failed. Please try again.",
        "makedrillthrudefaultfailure": "Assigning the selected drill view failed.Please retry this operation later.",
        "setviewsuccess": "View set successfully.",
        "setviewfailure": "Sorry, setting view failed. Please try again.",
        "reportupdationsuccess": "Report saved successfully.",
        "reportupdationfailure": "Sorry, saving report failed. Please try again.",
    }
    
    static ALLOWED_MEASURES = 5
    static ALLOWED_DIMENSIONS = 2
    static APPLY_HIGHLIGHT_DURATION = 3000 // in milliseconds

    static FILTER_EMPTY_Date_INPUT = "Please enter the value in the appropriate filterbox and try again."

    static NO_CHECKBOX_VALUE = "Please select at least one filter value and try again."
    static NO_DIMENSION ="Please select a dimension and try again."
    static NO_MEASURE = "Please select a measure and try again."
    static NO_FILTER = "Please select a value and try again."
    static DUPLICATE_DIMENSION_ROW = "Duplicate dimension(row) cannot be added to the report. Please edit the exisiting dimension in the report."
    static DUPLICATE_DIMENSION_COL = "Duplicate dimension(col) cannot be added to the report.Please edit the exisiting dimension in the report."
    static DUPLICATE_MEASURE = "Duplicate measure cannot be added to the report. Please edit the exisiting measure in the report."
    static DUPLICATE_FILTER = "Duplicate filter cannot be added to the report. Please edit the exisiting filter in the report."

    static NO_DATA_TYPE = "Please select a filter and try again."
    static NO_FilterSelected = "Please select a filter value and try again"

    static FILTER_ADDED_SUCCESS = "Filter added successfully. Click OK to add more filters or click close."
}
